// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@flip/Overrides/Widgets/Budget/ConfigureBudget";
import { mergeWithCss } from "@flip/XDL/Utilities";
import { css } from "styled-components";

configureBudgetStyles.cancelButton = {
    variant: "secondary",
};

configureBudgetStyles.twoButtonModalStyles = {
    submitButton: {
        variant: "primary",
    },
    modal: {
        sizeVariant: "medium",
    },
};

configureBudgetStyles.gridContainer = {
    gap: 10,
};

// XNG-Changes: FLIP-753 , FLIP-811
configureBudgetStyles.gridItems = {
    ...mergeWithCss(configureBudgetStyles.gridItems, {
        width: [12, 12, 9, 6, 6],
        css: css`
            &.table-grid-item > div {
                overflow-y: unset;
                overflow-x: unset;
            }
        `,
    }),
};
// XNG-Changes: FLIP-754
configureBudgetStyles.startDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 100%;
            .react-datetime-picker__calendar {
                z-index: 1263;
            }
        `,
    },
};

// XNG-Changes:FLIP-754
configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 100%;
            .react-datetime-picker__calendar {
                z-index: 1263;
            }
        `,
    },
};

// XNG-Changes:FLIP-754
configureBudgetStyles.titleTooltipWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
    `,
};
